export default "__VITE_ASSET__CM$PRuQI__"